/* Ayurvedic Wholesale – quantity = pack pricing.
   Pack discounts live in the "Pack" variants (Single 16% off MRP, Pack of 2 17%, Pack of 3 18%).
   Raising the quantity of a product used to multiply the Single price, so 2 x Single stayed at 16%.
   This script re-bundles units into the cheapest mix of packs everywhere a quantity is chosen:
     - product page / quick-add "Add to cart" with quantity >= 2
     - cart drawer and cart page quantity changes
   Units = Single + 2 x Pack of 2 + 3 x Pack of 3 (for the same product and other options);
   plan = as many Pack of 3 as possible, then a Pack of 2 for a remainder of 2, else a Single.
   Only uses packs that are in stock; if a needed variant is unavailable the cart is left as it is. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SIZES = { 'Single': 1, 'Pack of 2': 2, 'Pack of 3': 3 };
  var pCache = {};
  function prod(handle) {
    if (!pCache[handle]) pCache[handle] = fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); });
    return pCache[handle];
  }
  function packIdx(p) {
    for (var i = 0; i < (p.options || []).length; i++) { var o = p.options[i]; if ((o && o.name ? o.name : o) === 'Pack') return i; }
    return -1;
  }
  function sibling(p, v, pack, i) {
    return (p.variants || []).filter(function (x) {
      return x.options.every(function (o, j) { return j === i ? o === pack : o === v.options[j]; });
    })[0] || null;
  }
  /* Cheapest mix for n units. Returns {map:{variantId:qty}, ok:bool} */
  function plan(p, v, n) {
    var i = packIdx(p); if (i < 0) return null;
    var s = sibling(p, v, 'Single', i), p2 = sibling(p, v, 'Pack of 2', i), p3 = sibling(p, v, 'Pack of 3', i);
    var a = 0, b = 0, c = 0, rest = n;
    if (p3 && p3.available) { a = Math.floor(rest / 3); rest -= a * 3; }
    if (rest >= 2 && p2 && p2.available) { b = Math.floor(rest / 2); rest -= b * 2; }
    c = rest;
    if (c > 0 && !(s && s.available)) return null;
    var map = {};
    if (s) map[s.id] = c;
    if (p2) map[p2.id] = b;
    if (p3) map[p3.id] = a;
    return { map: map, packs: a + b + c, label: [a ? a + ' × Pack of 3' : '', b ? b + ' × Pack of 2' : '', c ? c + ' × Single' : ''].filter(Boolean).join(' + ') };
  }
  function drawer() { return document.querySelector('cart-drawer'); }
  function cartPage() { return document.getElementById('main-cart-items'); }
  /* Sections to re-render after a cart change: the cart page parts on /cart, else the drawer */
  function sectionsParam() {
    var page = cartPage(), foot = document.getElementById('main-cart-footer'), d = drawer();
    if (page) return [page.dataset.id, foot && foot.dataset.id, 'cart-icon-bubble'].filter(Boolean);
    return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }
  function swap(target, html, from) {
    var el = document.querySelector(target); if (!el || !html) return;
    var src = new DOMParser().parseFromString(html, 'text/html').querySelector(from);
    if (src) el.innerHTML = src.innerHTML;
  }
  /* Update only the cart markup in place (no page reload) */
  function refresh(res) {
    if (!res || !res.sections) return;
    var page = cartPage(), foot = document.getElementById('main-cart-footer'), d = drawer();
    if (page) {
      var empty = res.item_count === 0;
      document.querySelectorAll('cart-items, #main-cart-footer').forEach(function (el) { el.classList.toggle('is-empty', empty); });
      swap('#main-cart-items .js-contents', res.sections[page.dataset.id], '.js-contents');
      if (foot) swap('#main-cart-footer .js-contents', res.sections[foot.dataset.id], '.js-contents');
      swap('#cart-icon-bubble', res.sections['cart-icon-bubble'], '.shopify-section');
    } else if (d && d.renderContents) { d.classList.remove('is-empty'); d.renderContents(res); }
    if (typeof window.publish === 'function') try { window.publish('cart-update', { source: 'aw-packs', cartData: res }); } catch (e) {}
  }
  window.awCartSections = sectionsParam;
  window.awRenderCart = refresh;
  var toastT;
  function toast(msg) {
    var t = document.getElementById('aw-pack-toast');
    if (!t) { t = document.createElement('div'); t.id = 'aw-pack-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  }

  /* ---------- Product page & quick add: quantity >= 2 is added as packs ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || !/\/cart\/add/.test(f.action) || document.documentElement.classList.contains('aw-wa-on')) return;
    var pi = f.closest('product-info') || document.querySelector('product-info');
    var idEl = f.querySelector('input[name="id"]');
    var qEl = (f.id && document.querySelector('input[name="quantity"][form="' + f.id + '"]')) || f.querySelector('input[name="quantity"]');
    var qty = parseInt(qEl && qEl.value, 10) || 1;
    var url = pi && pi.dataset && pi.dataset.url;
    var h = url && (url.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!idEl || !h || qty < 2) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    prod(h).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return String(x.id) === String(idEl.value); })[0];
      var i = packIdx(p);
      var size = v && i >= 0 ? (SIZES[v.options[i]] || 1) : 1;
      var pl = v ? plan(p, v, qty * size) : null;
      var items = [];
      if (pl) { Object.keys(pl.map).forEach(function (id) { if (pl.map[id] > 0) items.push({ id: +id, quantity: pl.map[id] }); }); }
      else items.push({ id: +idEl.value, quantity: qty });
      return fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionsParam(), sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'Could not add to cart');
        if (pl && pl.label) toast('Added ' + pl.label + ' for the best pack price');
        if (drawer()) { refresh(res); setTimeout(normalise, 400); } else location.href = root + 'cart';
        if (qEl) { qEl.value = qEl.min || 1; }
      });
    }).catch(function (err) {
      var box = f.closest('product-form') && f.closest('product-form').querySelector('.product-form__error-message');
      if (box) { box.textContent = err.message; box.closest('.product-form__error-message-wrapper').hidden = false; } else alert(err.message);
    }).finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }, true);

  /* ---------- Cart (drawer + page): keep each product bundled into the cheapest packs ---------- */
  var busy = false, again = false;
  function normalise() {
    if (busy) { again = true; return Promise.resolve(); } busy = true; again = false;
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var groups = {};
      (cart.items || []).forEach(function (it) {
        var pk = (it.options_with_values || []).filter(function (o) { return o.name === 'Pack'; })[0];
        if (!pk || !SIZES[pk.value] || (it.selling_plan_allocation) || (it.properties && Object.keys(it.properties).length)) return;
        var others = (it.options_with_values || []).filter(function (o) { return o.name !== 'Pack'; }).map(function (o) { return o.value; }).join('|');
        var key = it.product_id + '|' + others;
        var g = groups[key] || (groups[key] = { handle: it.handle, units: 0, lines: {}, any: it.variant_id });
        g.units += it.quantity * SIZES[pk.value];
        g.lines[it.variant_id] = (g.lines[it.variant_id] || 0) + it.quantity;
      });
      var keys = Object.keys(groups).filter(function (k) { var g = groups[k]; return g.units >= 2; });
      if (!keys.length) return;
      return Promise.all(keys.map(function (k) {
        var g = groups[k];
        return prod(g.handle).then(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.id === g.any; })[0];
          var pl = v && plan(p, v, g.units); if (!pl) return null;
          var changed = Object.keys(pl.map).some(function (id) { return (g.lines[id] || 0) !== pl.map[id]; });
          return changed ? pl : null;
        }).catch(function () { return null; });
      })).then(function (plans) {
        var updates = {}, labels = [];
        plans.forEach(function (pl) { if (pl) { Object.keys(pl.map).forEach(function (id) { updates[id] = pl.map[id]; }); labels.push(pl.label); } });
        if (!Object.keys(updates).length) return;
        lock(true);
        return fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: sectionsParam(), sections_url: location.pathname })
        }).then(function (r) { return r.json(); }).then(function (res) {
          toast('Bundled as ' + labels.join(', ') + ' for the best pack price');
          refresh(res);
        });
      });
    }).catch(function () {}).finally(function () { busy = false; if (again) { setTimeout(normalise, 50); } else { lock(false); } });
  }
  /* While re-bundling, block quantity taps so line-number based updates cannot hit a shifted line */
  function lock(on) {
    document.querySelectorAll('cart-drawer-items, cart-items').forEach(function (el) { el.classList.toggle('aw-busy', on); });
  }
  if (typeof window.subscribe === 'function') {
    try { window.subscribe('cart-update', function (ev) { if (ev && ev.source === 'aw-packs') return; lock(true); setTimeout(normalise, 150); }); } catch (e) {}
  }
  document.addEventListener('DOMContentLoaded', function () { normalise(); });

  /* ---------- Product page hint next to quantity ---------- */
  function hint() {
    document.querySelectorAll('product-info').forEach(function (pi) {
      var q = pi.querySelector('.product-form__quantity'); if (!q || q.querySelector('.aw-qhint')) return;
      if (!pi.querySelector('variant-selects input[value="Pack of 3"], variant-selects option[value="Pack of 3"]')) return;
      q.insertAdjacentHTML('beforeend', '<p class="aw-qhint">Buy 2: <b>17% off</b> · Buy 3: <b>18% off</b> – best pack price applied automatically</p>');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hint); else hint();
  new MutationObserver(function () { hint(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
